var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRunApi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1H1V7H15V1ZM0 0V8H16V0H0Z",
    fill: "#6B6B6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53516 5.30127H5.28711L5.46094 4.68213H6.38086L6.55469 5.30127H7.30664L6.35938 2.48291H5.48242L4.53516 5.30127ZM5.90234 3.104H5.93945L6.23633 4.1665H5.60547L5.90234 3.104Z",
    fill: "#6B6B6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7793 5.30127H8.49609V4.4751H8.99219C9.62305 4.4751 10.0293 4.08838 10.0293 3.48486V3.48096C10.0293 2.87744 9.62305 2.48291 8.99219 2.48291H7.7793V5.30127ZM8.82031 3.03174C9.125 3.03174 9.30469 3.18799 9.30469 3.48096V3.48486C9.30469 3.77783 9.125 3.93604 8.82031 3.93604H8.49609V3.03174H8.82031Z",
    fill: "#6B6B6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5566 5.30127H11.2734V2.48291H10.5566V5.30127Z",
    fill: "#6B6B6B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunApi);
export default __webpack_public_path__ + "static/media/runApi.385f742f523ae0ee3e3c31e6df40d72c.svg";
export { ForwardRef as ReactComponent };